import { Injectable } from '@angular/core';
import { CardsService } from '../services/cards.service';
import { NotificationFacade } from '../../notifications';
import * as ACTIONS from './cards.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CardsEffects {
    constructor(
        private actions$: Actions,
        private notification: NotificationFacade,
        private service: CardsService,
        private router: Router,
        private translate: TranslateService
    ) {}

    fetchCustomerCards$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ACTIONS.fetchCustomerCards),
            mergeMap(() =>
                this.service.getCustomerCards().pipe(
                    map(
                        (customerCards) => ACTIONS.fetchCustomerCardsSuccess({ customerCards }),
                        catchError(() => {
                            this.notification.error(this.translate.instant('CUSTOMER_CARD_LOAD_FAILED'));
                            return of(ACTIONS.fetchCustomerCardsFailed());
                        })
                    )
                )
            )
        );
    });

    blockCard$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ACTIONS.blockCard),
            mergeMap(({ card }) => {
                return this.service.blockCard(card).pipe(
                    map(() => ACTIONS.fetchCustomerCards()),
                    tap(() => this.notification.success(this.translate.instant('LOCAL_RELATED_CARD_BLOCKED'))),
                    catchError(() => {
                        this.notification.error(this.translate.instant('LOCAL_RELATED_CARD_BLOCKED_FAIL'));
                        return of(ACTIONS.blockCardFailed());
                    })
                );
            })
        );
    });

    unblockCard$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ACTIONS.unblockCard),
            mergeMap(({ card }) => {
                return this.service.unblockCard(card).pipe(
                    map(() => ACTIONS.fetchCustomerCards()),
                    tap(() => this.notification.success(this.translate.instant('LOCAL_RELATED_CARD_UNBLOCKED'))),
                    catchError(() => {
                        this.notification.error(this.translate.instant('LOCAL_RELATED_CARD_UNBLOCKED_FAIL'));
                        return of(ACTIONS.unblockCardFailed());
                    })
                );
            })
        );
    });

    deleteRelatedCard$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ACTIONS.deleteRelatedCard),
            mergeMap(({ card }) => {
                return this.service.deleteRelatedCard(card).pipe(
                    map(() => ACTIONS.fetchCustomerCards()),
                    tap(async () => {
                        await this.router.navigate([this.translate.currentLang, 'account', 'cards']);
                        this.notification.success(this.translate.instant('RELATED_CARD_DELETED'));
                    }),
                    catchError(() => {
                        this.notification.error(this.translate.instant('FAILED_TO_DELETE_RELATED_CARD'));
                        return of(ACTIONS.deleteRelatedCardFailed());
                    })
                );
            })
        );
    });
}
